import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/airports', request, cancelToken)
}

export {get}
